<template>
<div :class="`slds-notify slds-notify_alert slds-theme_alert-texture slds-theme_${type}`" role="alert">
  <span class="slds-assistive-text">{{$t(`general.${type}`)}}</span>
  <span class="slds-icon_container slds-m-right_x-small" :class="`slds-icon-utility-${type}`">
    <svg class="slds-icon slds-icon_x-small" aria-hidden="true">
      <use v-if="type === 'error'" xlink:href="../../assets/symbols.svg#error"></use>
      <use v-if="type === 'warning'" xlink:href="../../assets/symbols.svg#warning"></use>
    </svg>
  </span>
  <h2>{{message}}</h2>
  <div class="slds-notify__close">
    <button class="slds-button slds-button_icon slds-button_icon-small slds-button_icon-inverse" title="Close">
      <svg class="slds-button__icon" aria-hidden="true">
        <use xlink:href="../../assets/symbols.svg#lose"></use>
      </svg>
    </button>
  </div>
</div>
</template>
<script>
export default {
  props: {
    message: {
      type: String,
      required: true
    },
    type: {
      type: String,
      required: true
    },
  },

}
</script>
<style>
</style>
